import { Box } from '@doltech/ui/lib/figma/Common/Box';
import * as React from 'react';
import styled from 'styled-components';

const QuestionBoxWrapper = styled(Box)``;

export const QuestionBoxId = 'question-box';
export const QuestionBoxMobile = ({ children }: any) => {
  return <QuestionBoxWrapper id={QuestionBoxId}>{children}</QuestionBoxWrapper>;
};
